import { Component } from 'react';
import { observer } from 'mobx-react';
import { Checkbox, CheckboxGroup, Field, Form, FormGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { Button, Col, Label, Row } from 'reactstrap';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { DateField } from '@availity/date';
import moment from 'moment';
import AddFile from '@/Common/components/AddFile';
import withNavigate from '../../Common/components/withNavigate';
import ReimbursementStore from '../stores';
import CustomProgressBar from '../CustomProgressBar/CustomProgressBar';
import expenditureCategories from '../../../data/expenditureCategories.json';

@observer
class Documentation extends Component {

    componentDidMount() {
        if (window.performance) {
            if (performance.navigation.type == 1) {
                const contextPath = window.location.pathname;
                window.location.href = contextPath;
            }
        }

        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

    setDocumentation = (value, group) => {
        if (group === 'docCheck') {
            ReimbursementStore.setDocumentUpload(value);
        } else if (group === 'docCheck1') {
            ReimbursementStore.setDocumentUpload1(value);
        }
        if (group === 'docCheck2') {
            ReimbursementStore.setDocumentUpload2(value);
        }
    }

    submit = () => {
        const { navigate } = this.props;
        ReimbursementStore.setReimbursementPageStatus("#documentation", 'complete');
        navigate('/reviewsubmit');
    }

    back = () => {
        const { navigate } = this.props;
        navigate('/movingattestation');
    }

    resetDocumentObj = (index) => {
        ReimbursementStore.resetDocumentObj(index);
    }

    render() {
        const {
            reimbursementFormPages,
            documentupload,
            documentupload1,
            documentupload2,
            documentUploadDetails,
            expenditureDetails
        } = ReimbursementStore;

        const isRentalArrearsRequired = expenditureDetails.some(
            x => x.expenditureCategory === 'Arrears: Rental'        );
        const isArrearsUtilityRequired = expenditureDetails.some(
            x => x.expenditureCategory === 'Arrears: Utility'
        );


        return (
            <>
                <div className="border-form">
                    <Form
                        enableReinitialize
                        initialValues={{
                            docCheck: documentupload,
                            docCheck1: documentupload1,
                            docCheck2: documentupload2,
                            Rental_Arrears_Field_value: documentUploadDetails[0]?.percetComp === 100 ? documentUploadDetails[0]?.fileName : '',
                            Other_doc_Field_value: documentUploadDetails[1]?.percetComp === 100 ? documentUploadDetails[1]?.fileName : '',
                            Arrears_Utility_Field_value: documentUploadDetails[2]?.percetComp === 100 ? documentUploadDetails[2]?.fileName : '',
                        }}
                        validationSchema={yup.object().shape({
                            ...(documentupload.includes("opt1") ? { Rental_Arrears_Field_value: yup.string().required(documentUploadDetails[0]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
                            ...(documentupload1.includes("opt2") ? { Other_doc_Field_value: yup.string().required(documentUploadDetails[1]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
                            ...(documentupload2.includes("opt3") ? { Arrears_Utility_Field_value: yup.string().required(documentUploadDetails[0]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
                            ...(isRentalArrearsRequired ? { docCheck: yup.array().min(1, "Rental Arrears document is required.") } : {}),
                            ...(isArrearsUtilityRequired ? { docCheck2: yup.array().min(1, "Utility Arrears  document is required.") } : {}),
                        })}
                        onSubmit={this.submit}
                    >
                        <CustomProgressBar pages={reimbursementFormPages} page="#documentation" />
                        <div>
                            <small className="required-fields">*required</small>
                            <div className="spacer-48" />
                            <h2 className="poppinsH2" id="fcs-tap-heading">Upload Documents</h2>
                        </div>
                        <div className='mt-5' />
                        <p>TAP Exception to Policy (ETP) rental arrears requests require supporting documentation. Upload the enrollee’s rental ledger or any other official document that verifies the amount owed by the enrollee. Ensure the requested amount matches the amount stated in the submitted rental arrears documentation.</p>
                         <p> To process UTILITY arrears requests, Wellpoint requires supporting documentation. Upload a copy of the enrollee's utility bill or any other official document that verifies the amount owed by the enrollee. Ensure that the requested amount matches the amount stated in the submitted documentation</p>
                        <div className='spacer-16' />
                        <strong>Upload Documents</strong>
                        <div className="spacer-rem" />
                        <CheckboxGroup name="docCheck" value={documentupload} onChange={value => this.setDocumentation(value, 'docCheck')}>
                            <Checkbox
                                label="Rental Arrears"
                                name="Rental Arrears Doc"
                                id="Rental Arrears Doc"
                                className="label-font mb-23 no-display"
                                groupName="docCheck"
                                value="opt1"
                            />
                            {documentupload.includes("opt1") ?
                                <AddFile fieldId={'Rental_Arrears_Field'} fileObj={documentUploadDetails[0]} index={0} propsData={{ documentName: 'Rental Arrears' }} />
                                : this.resetDocumentObj(0)
                            }

                        </CheckboxGroup>
                        <div className="mt-20" />
                        <CheckboxGroup name="docCheck2" value={documentupload2} onChange={value => this.setDocumentation(value, 'docCheck2')}>
                            <Checkbox
                                label="Utility Arrears"
                                name="Utility Arrears doc"
                                id="Utility Arrears doc"
                                className="label-font mb-23 no-display"
                                groupName="docCheck2"
                                value="opt3"
                            />
                            {documentupload2.includes("opt3") ?
                               <AddFile fieldId={'Arrears_Utility_Field'} fileObj={documentUploadDetails[2]} index={2} propsData={{ documentName: 'Utility Arrears' }} />
                                : this.resetDocumentObj(2)
                            }
                        </CheckboxGroup>
                        <div className="mt-20" />
                        <CheckboxGroup name="docCheck1" value={documentupload1} onChange={value => this.setDocumentation(value, 'docCheck1')}>
                            <Checkbox
                                label="Other"
                                name="other doc"
                                id="other doc"
                                className="label-font mb-23 no-display"
                                groupName="docCheck1"
                                value="opt2"
                            />
                            {documentupload1.includes("opt2") ?
                                <AddFile fieldId={'Other_doc_Field'} fileObj={documentUploadDetails[1]} index={1} propsData={{ documentName: 'Other' }} />
                                : this.resetDocumentObj(1)
                            }
                        </CheckboxGroup>
                        <div className="spacer-48" />
                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                            Next
                        </Button>
                        <Button type="button" color={"primary"} className={'btn btn-primary backButton'} onClick={this.back}>
                            Back
                        </Button>
                        <div className="pb-spacerRem-10" />
                    </Form>
                </div>
            </>
        );
    }
}

export default withNavigate(Documentation);

Documentation.propTypes = {
    navigate: PropTypes.func
};